import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InfoTip } from "../InfoTip";
import "../tactic/TacticEditor.css";

/**
 * @param {{ currentName: string, onSave: (name: string) => Promise, onClose: () => void }} props
 */
export function RenameTeamModal({ currentName, onSave, onClose }) {
  const { t } = useTranslation();
  const [name, setName]   = useState(currentName);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) { setError(t("team.nameRequired")); return; }
    if (trimmed === currentName) { onClose(); return; }
    setSaving(true);
    try {
      await onSave(trimmed);
      onClose();
    } catch (err) {
      setError(err.message === "TEAM_NAME_TAKEN" ? t("team.nameTaken") : err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" style={{ maxWidth: 360 }} onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <span className="modal-title" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
            {t("team.rename")}
            <InfoTip message={t("team.namePolicy")} />
          </span>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <input
          ref={inputRef}
          type="text"
          value={name}
          onChange={(e) => { setName(e.target.value); setError(""); }}
          onKeyDown={(e) => { if (e.key === "Enter") handleSave(); if (e.key === "Escape") onClose(); }}
          maxLength={30}
          style={{ background: "#161616", border: "1px solid #444", borderRadius: 4, color: "#d4d4d4", fontSize: "0.95rem", padding: "6px 10px", width: "100%", boxSizing: "border-box" }}
          disabled={saving}
        />
        {error && <span style={{ color: "#e05555", fontSize: "0.8rem" }}>{error}</span>}

        <div className="modal-footer">
          <div />
          <div className="modal-actions">
            <button className="modal-cancel-btn" onClick={onClose} disabled={saving}>{t("cancel")}</button>
            <button className="modal-save-btn" onClick={handleSave} disabled={saving}>{t("save")}</button>
          </div>
        </div>

      </div>
    </div>
  );
}
